import { TFunction } from '@lyearn/i18n';
import { ActionItemFragment } from '@/modules/tasks/features/actionItems/graphql/fragments/generated/ActionItem';
import { CreateActionItemInput, RelatedEntityInput } from '@/types/schema';

export const getDuplicateTaskInitialValues = ({
  t,
  task,
}: {
  t: TFunction;
  task: ActionItemFragment;
}) => {
  return {
    duplicateFromId: task.id,
    title: `${t('Common:CopyOf')} ${task.title}`,
  };
};

export default function getDuplicateTaskValues({
  t,
  task,
  entityDetails,
}: {
  t: TFunction;
  task: ActionItemFragment;
  entityDetails: Partial<RelatedEntityInput>;
}): CreateActionItemInput {
  const {
    title,
    status,
    priority,
    assignedToId,
    dueDate,
    fileId,
    instruction,
    assignedToIds,
    labelCategoryId,
    tags,
    // not using entityId and entityType from task because
    // they are only populated at creation time, and we want to duplicate in the context of where task is shown
    entityId,
    entityType,
    parentId,
    statusId,
    category,
  } = task;

  return {
    title: `${t('Common:CopyOf')} ${title}`,
    statusId,
    status,
    category,
    priority,
    assignedToId,
    assignedToIds: assignedToIds?.filter((id): id is string => Boolean(id)),
    dueDate,
    tags: tags as any, //DO LATER: write a common type for ActionItemFragment and CreateActionItemInput to handle this in AddOrEditTaskDialog
    fileId,
    instruction,
    labelCategoryId,
    entity:
      entityDetails.entityId && entityDetails.entityType
        ? {
            entityId: entityDetails.entityId,
            entityType: entityDetails.entityType,
          }
        : undefined,
    parentId,
  };
}
